<template>
	<div class="conversation-anchor" v-if="conversationGroups.length > 1">
		<div class="anchor-wrapper" @mouseenter="anchorPanelVisible = true" @mouseleave="anchorPanelVisible = false">
			<!-- 对话列表预览面板 -->
			<transition name="anchor-panel-fade">
				<div class="anchor-panel" v-show="anchorPanelVisible">
					<div class="anchor-panel-header">对话列表</div>
					<div class="anchor-panel-list">
						<div
							v-for="(group, index) in conversationGroups"
							:key="index"
							:class="['anchor-panel-item', { 'anchor-panel-item-active': activeAnchorIndex === index }]"
							@click="handleScrollTo(index)"
						>
							<span class="anchor-panel-num">{{ index + 1 }}</span>
							<span class="anchor-panel-text">{{ truncateText(group.question, 25) }}</span>
						</div>
					</div>
				</div>
			</transition>
			<!-- 锚点轨道 -->
			<div class="anchor-track">
				<div
					v-for="(group, index) in conversationGroups"
					:key="index"
					:class="['anchor-dot', { 'anchor-dot-active': activeAnchorIndex === index }]"
					@click="handleScrollTo(index)"
					:title="'第' + (index + 1) + '轮对话'"
				>
					<span class="anchor-line"></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AnchorNav',
	props: {
		conversationGroups: {
			type: Array,
			default: () => []
		},
		activeAnchorIndex: {
			type: Number,
			default: -1
		}
	},
	data() {
		return {
			anchorPanelVisible: false
		};
	},
	methods: {
		handleScrollTo(index) {
			this.anchorPanelVisible = true;
			this.$emit('scroll-to', index);
		},
		truncateText(text, maxLen = 25) {
			if (!text) return '';
			return text.length > maxLen ? text.substring(0, maxLen) + '...' : text;
		}
	}
};
</script>

<style lang="less" scoped>
.conversation-anchor {
	position: fixed;
	right: 20px;
	top: 50%;
	transform: translateY(-50%);
	z-index: 10;

	.anchor-wrapper {
		position: relative;
		display: flex;
		align-items: center;
	}

	.anchor-track {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 10px;
		padding: 8px 6px;
		border-radius: 12px;
		background: rgba(255, 255, 255, 1);
		backdrop-filter: blur(4px);
		transition: background 0.2s ease;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);

		&:hover {
			background: rgba(255, 255, 255, 0.9);
		}
	}

	.anchor-dot {
		width: 20px;
		height: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		.anchor-line {
			width: 14px;
			height: 2px;
			background: #c0c4cc;
			border-radius: 1px;
			transition: all 0.2s ease;
		}

		&:hover .anchor-line {
			background: #909399;
			width: 18px;
			height: 3px;
		}

		&.anchor-dot-active .anchor-line {
			background: #155dfc;
			width: 18px;
			height: 3px;
		}
	}

	// 对话预览面板
	.anchor-panel {
		position: absolute;
		right: -10px;
		top: 50%;
		transform: translateY(-50%);
		background: #fff;
		border: 1px solid #e2e8f0;
		border-radius: 12px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
		width: 280px;
		max-height: 420px;
		overflow: hidden;

		.anchor-panel-header {
			padding: 12px 16px;
			font-size: 13px;
			font-weight: 600;
			color: #64748b;
			border-bottom: 1px solid #f1f5f9;
		}

		.anchor-panel-list {
			max-height: 362px;
			overflow-y: auto;
			padding: 4px 0;
			scrollbar-width: thin;

			&::-webkit-scrollbar {
				width: 4px;
			}

			&::-webkit-scrollbar-thumb {
				background: #e2e8f0;
				border-radius: 2px;
			}
		}

		.anchor-panel-item {
			display: flex;
			align-items: center;
			gap: 10px;
			padding: 8px 16px;
			cursor: pointer;
			transition: background 0.15s ease;

			&:hover {
				background: #f1f5f9;
			}

			&.anchor-panel-item-active {
				background: #eff6ff;

				.anchor-panel-num {
					background: #155dfc;
					color: #fff;
				}
			}
		}

		.anchor-panel-num {
			flex-shrink: 0;
			width: 22px;
			height: 22px;
			border-radius: 50%;
			background: #f1f5f9;
			color: #64748b;
			font-size: 11px;
			font-weight: 600;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.anchor-panel-text {
			font-size: 13px;
			color: #334155;
			line-height: 1.5;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			flex: 1;
			min-width: 0;
			margin-right: 26px;
		}
	}
}

/* 锚点面板过渡动画 */
.anchor-panel-fade-enter-active,
.anchor-panel-fade-leave-active {
	transition: opacity 0.2s ease, transform 0.2s ease;
}

.anchor-panel-fade-enter,
.anchor-panel-fade-leave-to {
	opacity: 0;
	transform: translateX(12px);
}
</style>
